module.exports = __webpack_public_path__ + "img/rtl.4b190414.jpg";